import axios from 'axios'
import qs from 'qs'
export const LOAD_FUND_PROFILE = 'load_fundProfile'
export const LOAD_RELATED_FUNDS = 'load_related_funds'
export const REMOVE_RELATED_FUND = 'remove_related_funds'
export const LOAD_PERFORMANCE = 'load_performance'
export const SET_INDEX = 'set_index'
export const SET_PROFILE_CATEGORY = 'setProfileCategory'
export const SET_SAMPLE_PARAM = 'set_sample_param'
export const SET_SELECTED_FUND_TICKERS = 'set_selected_fund_tickers'
export const SET_TA_FUND_TICKERS = 'set_ta_fund_tickers'
export const RESET_PAGE = 'reset_page'
export const SET_SELECTED_CHARS = 'set_selected_chars'
export const SET_SELECTED_SECTOR = 'set_selected_sector'
export const SET_SELECTED_COUNTRY = 'set_selected_country'
export const RESET_SCROLL_COUNTRY = 'reset_scroll_country'
export const SET_ACTIVE_PANE = 'set_active_pane'
export const REMOVE_TICKER = 'remove_ticker'
export const CLEAR_TICKERS = 'clear_tickers'
export const CLEAR_INITIAL_TICKERS = 'clear_initial_tickers'
export const LOADING = 'loading'

export const HAS_BLENDED_DATA = 'hasBlendedData'

export const FETCH_STRUCTURE_LOADING = 'fetchStructureLoading'
export const FETCH_STRUCTURE_ERROR = 'fetchStructureError'
export const SET_FUND_DETAILS_STRUCTURE = 'setFundDetails'

export const FETCH_PERFORMANCE_LOADING = 'fetchPerformanceLoading'
export const FETCH_PERFORMANCE_ERROR = 'fetchPerformanceError'
export const SET_FUND_DETAILS_PERFORMANCE = 'setFundDetailsPerformance'

export const FETCH_AGGS_LOADING = 'fetchAggsLoading'
export const FETCH_AGGS_ERROR = 'fetchAggsError'
export const SET_FUND_DETAILS_AGGS = 'setFundDetailsAggs'

export const FETCH_CONSTITUENTS_LOADING = 'fetcConstituentsLoading'
export const FETCH_CONSTITUENTS_ERROR = 'fetcConstituentsERROR'
export const SET_FUND_DETAILS_CONSTITUENTS = 'setFundDetailsConstituents'

export const FETCH_CATCHALL_LOADING = 'fetchCatchAllLoading'
export const FETCH_CATCHALL_ERROR = 'fetchCatchAllError'
export const SET_FUND_DETAILS_CATCHALL = 'setFundDetailsCatchAll'

export const FETCH_RUN_ID_LOADING = 'fetchRunIDLoading'
export const FETCH_RUN_ID_ERROR = 'fetchRunIDError'
export const SET_FUND_DETAILS_RUN_ID = 'setFundDetailsRunID'

export const SET_PROGRESS_BAR_VALUE= 'setProgressBarBalue'

export const FETCH_AGGS_FULL_LOADING = 'aggFullLoading'
export const SET_AGGS_FULL_COMPLETED = 'aggFullLoadComplete'

export const ADD_PENDING_DATASPAN_REQUESTS = 'addPendingDataspanRequests'
export const REMOVE_PENDING_DATASPAN_REQUESTS = 'removePendingDataspanRequests'

export const PERF_LOADING = 'perfLoading'
export const ERROR = 'error'
export const SELECTED_RELATED = 'selected_related'
export const SET_PERF_START_DATE = 'set_perf_start_date'
export const SET_PERF_END_DATE = 'set_perf_end_date'
export const SET_FULLEXCEL_STATUS = 'set_fullexcelstatus'
export const SET_CURRENTEXCEL_STATUS = 'set_currentexcelstatus'
export const SET_CURRENT_URL = 'set_current_url'
export const SET_GROWTH_METRIC_QUALITY = 'set_growth_metric_quality'
export const SET_ALL_GROWTH_CHARS = 'set_all_growth_chars'
export const SET_SELECT_ADDITIONALPI = 'set_select_additionalpi'
export const SET_SELECTED_RISK = 'set_selected_risk'
export const SET_DRAW_DOWN_PERIOD = 'set_draw_down_period'
export const SET_ACTIVE_SOE_PANE = 'set_active_soe_pane'
export const SET_ACTIVE_SOE_DATA_TYPE = 'set_active_soe_data_type'
export const TOGGLE_SHOW_FUND_SELECTION = 'toggle_show_fund_selection'
export const LOAD_SEARCH_RESULTS = 'load_search_results'
export const LOADING_SEARCH_RESULTS = 'loading_search_results'
export const ADD_SCREENED_FUND = 'add_screened_fund'
export const CLEAR_SCREENED_FUNDS = 'clear_screened_funds'
export const CLEAR_SEARCH_RESULTS = 'clear_search_results'
export const LOAD_PERSONAL_STRATEGIES = 'get_personal_strategies'
export const DELETE_A_STRATEGY = 'delete_a_stategy'
export const SHOW_A_STRATEGY = 'show_a_stategy'
export const SHOW_ALL_STRATEGIES = 'show_all_stategies'
export const SHOW_STRATEGY_EDITOR = 'show_strategy_editor'
export const CLOSE_STRATEGY_EDITOR = 'close_strategy_editor'
export const UPDATE_STRATEGY = 'update_strategy'
export const LOAD_TYPEAHEAD_SUGGESTIONS = 'load_typeahead_suggestions'
export const SAVING_NEW_STRATEGY_IN_PROGRESS = 'saving_new_strategy_in_progress'
export const SAVING_STRATEGY_IN_PROGRESS = 'saving_strategy_in_progress'
export const SAVING_STRATEGY_COMPLETE = 'saving_strategy_complete'
export const SAVE_NEW_STRATEGY = 'save_new_strategy'
export const LOAD_BENCHMARKS = 'load_benchmarks'
export const REMOVE_SCREENED_FUND = 'remove_screened_fund'
export const UPDATE_SEARCH_TICKER = 'update_search_ticker'
export const APPEND_SEARCH_TICKER = 'append_search_ticker'
export const REMOVE_SEARCH_TICKER = 'remove_search_ticker'
export const EDIT_TICKERS = 'edit_tickers'
export const UPDATE_FUND_COUNT = 'update_fund_count'
const API_URL = process.env.REACT_APP_API_URL
// const FUNDCHAR_URL_BLNEDS = `${API_URL}/fundchar/blends/?` <- call all data endpoint.
const FUNDCHAR_URL_STRUCTURE = `${API_URL}/fundchar/blends_structure/?`
const FUNDCHAR_URL_PERFORMANCE = `${API_URL}/fundchar/blends_performance/?`
const FUNDCHAR_URL_AGGREGATES = `${API_URL}/fundchar/blends_aggregates/?`
const FUNDCHAR_URL_CONSTITUENTS = `${API_URL}/fundchar/blends_constituents/?`
const FUNDCHAR_URL_CATCH = `${API_URL}/fundchar/blends_catch_exposures/?`
const FUNDCHAR_URL_PDF_RUN_ID = `${API_URL}/fundchar/blends_pdf_run_id/?`

export const paneOpts = {
  metrics: 'metrics',
  chars: 'chars',
  expos: 'expos',
  perf: 'perf',
  details: 'details',
  factors: 'factors',
  esg: 'esg'
}

export function updateQueryParams() {
  return (dispatch, getState) => {
    if (getState().fundData.data) {
      const tickers = getState()
        .fundData.data.map(fund => {
          return fund.ticker
        })
        .join()
      const tab = getState().params.activePane
      const startDate = getState().params.perfStartDate
      const endDate = getState().params.perfEndDate
      let newHash = `#fund-comparison&tickers=${tickers}&tab=${tab}`
      if (startDate && endDate && tab === paneOpts.perf) {
        newHash += `&startDate=${startDate}&endDate=${endDate}`
      }
      window.history.replaceState(null, null, newHash)
      dispatch({ type: SET_CURRENT_URL, value: window.location.origin + window.location.pathname + newHash })
    }
  }
}

//edit tickers

export function editQueryParams() {
  return (dispatch, getState) => {
    if (getState().fundData.data) {
      const tickers = getState()
        .fundData.data.map(fund => {
          return fund.ticker
        })
        .join()
      const tab = getState().params.activePane
      const startDate = getState().params.perfStartDate
      const endDate = getState().params.perfEndDate
      let newHash = `#fund-comparison&tickers=${tickers}&tab=${tab}`
      if (startDate && endDate && tab === paneOpts.perf) {
        newHash += `&startDate=${startDate}&endDate=${endDate}`
      }
      window.history.replaceState(null, null, newHash)
      dispatch({ type: SET_CURRENT_URL, value: window.location.origin + window.location.pathname + newHash })
    }
  }
}

// loads basic fund profile ( categories / classifications/ tickers )
export function loadFundProfile() {
  return (dispatch, getState) => {
    const request = {
      method: 'GET',
      url: `${process.env.REACT_APP_API_URL}/fundchar/profiles?wtRegion=${getState().params.wtRegion}`
    }
    return axios(request)
      .then(response => {
        // dispatch({ type: LOAD_FUND_PROFILE, payload: response.data })
        dispatch({ type: LOAD_FUND_PROFILE, payload: response })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads related WT funds
export function loadRelatedFunds(selectedFunds) {
  return (dispatch, getState) => {
    const funds = selectedFunds.map(fund => fund.value)
    const fundCount = funds.length + getState().params.selectedFunds.length
    if (fundCount > 0 && fundCount < 6 && !getState().params.selectedRelated) {
      const extIds = funds.join(',')
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/fundchar/related_funds?wtRegion=${getState().params.wtRegion}&externalIds=${extIds}`
      }
      return axios(request)
        .then(response => {
          const relatedFunds = response.data.filter(fund => !funds.includes(fund.externalID))
          dispatch({ type: LOAD_RELATED_FUNDS, payload: relatedFunds })
        })
        .catch(error => {
          console.log(error)
        })
    } else {
      if (!getState().params.selectedRelated) {
        dispatch({ type: LOAD_RELATED_FUNDS, payload: [] })
      }
      dispatch({ type: SELECTED_RELATED, payload: false })
    }
  }
}

// ****** BLEND FUNCTIONS START ******

export function loadFundDetailsPortfolio(aggNoHistoryFlag, levelsEndDate) {

  return async (dispatch, getState) => {
    const fundsList = await getState().params.screenedFunds.slice(0, 6);
    const fundData = await getState().fundData.data
    const pendingDataspanRequests = await getState().fundData.pendingDataspanRequests
    await cancelRequests(pendingDataspanRequests)


    const isRefreshing = await checkIsRefresh(fundsList, fundData)
    const hasBlend = fundsList.some(item => item.type.toLowerCase() === "blend");

    if (levelsEndDate) {
      dispatch(setPerfLoading(true))
    } else {
      handleDefaultLoading(dispatch)
    }

    await dispatch({ type: CLEAR_SEARCH_RESULTS })

    try {
      if (isRefreshing) {
        await dispatch({ type: FETCH_STRUCTURE_LOADING, payload: true})
        await processInitialStrctureRefresh(dispatch, fundsList, false, levelsEndDate, fundData)
        await dispatch({ type: HAS_BLENDED_DATA, payload: hasBlend })
        await dispatch({ type: FETCH_PERFORMANCE_LOADING, payload: true })
        await dispatch({ type: FETCH_PERFORMANCE_ERROR, payload: false })
        await dispatch({ type: FETCH_CONSTITUENTS_LOADING, payload: true })
        await dispatch({ type: FETCH_CONSTITUENTS_ERROR, payload: false })
        await dispatch({ type: FETCH_CATCHALL_LOADING, payload: true})
        await dispatch({ type: FETCH_CATCHALL_ERROR, payload: false})
        await dispatch({ type: FETCH_AGGS_LOADING, payload: true})
        await dispatch({ type: FETCH_AGGS_ERROR, payload: false})
        await dispatch({ type: FETCH_RUN_ID_LOADING, payload: true})
        await dispatch({ type: FETCH_RUN_ID_ERROR, payload: false})
        await Promise.all([
          processPerformance(dispatch, fundsList, false, levelsEndDate),
          processAggregates(dispatch, fundsList, true, levelsEndDate),
          processConstituents(dispatch, fundsList, false, levelsEndDate),
          processCatchAll(dispatch, fundsList, true, levelsEndDate)
        ]);
        await dispatch({ type: SET_PROGRESS_BAR_VALUE, payload: 0})
        await processPDFRunID(dispatch, fundsList, getState().fundData.data, getState().params) 
        await saveToSalesforce(getState().params, getState().fundData.data)
        await dispatch(saveToGA('Analyze'))
        await dispatch(saveToGA(getState().params.activePane))              
        await processCatchAll(dispatch, fundsList, false, levelsEndDate)
        await processAggregates(dispatch, fundsList, false, levelsEndDate)
      } else {
        await dispatch({ type: HAS_BLENDED_DATA, payload: hasBlend })
        await dispatch({ type: FETCH_PERFORMANCE_LOADING, payload: true })
        await dispatch({ type: FETCH_PERFORMANCE_ERROR, payload: false })
        await dispatch({ type: FETCH_CONSTITUENTS_LOADING, payload: true })
        await dispatch({ type: FETCH_CONSTITUENTS_ERROR, payload: false })
        await dispatch({ type: FETCH_CATCHALL_LOADING, payload: true})
        await dispatch({ type: FETCH_CATCHALL_ERROR, payload: false})
        await dispatch({ type: FETCH_AGGS_LOADING, payload: true})
        await dispatch({ type: FETCH_AGGS_ERROR, payload: false})
        await dispatch({ type: FETCH_RUN_ID_LOADING, payload: true})
        await dispatch({ type: FETCH_RUN_ID_ERROR, payload: false})
        await processInitialStrcture(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate, fundData)
        await Promise.all([
          processPerformance(dispatch, fundsList, false, levelsEndDate),
          processAggregates(dispatch, fundsList, true, levelsEndDate),
          processConstituents(dispatch, fundsList, false, levelsEndDate),
          processCatchAll(dispatch, fundsList, true, levelsEndDate)
        ]);
        await dispatch({ type: SET_PROGRESS_BAR_VALUE, payload: 0})
        await processPDFRunID(dispatch, fundsList, getState().fundData.data)
        await saveToSalesforce(getState().params, getState().fundData.data)
        await dispatch(saveToGA('Analyze'))
        await dispatch(saveToGA(getState().params.activePane))        
        await processCatchAll(dispatch, fundsList, false, levelsEndDate)
        await processAggregates(dispatch, fundsList, false, levelsEndDate)
      }
      } catch (error) {
        console.log(error)
    }
  }
}

async function checkIsRefresh(fundsList, fundData) {
  //check fundData first
  if (!fundData || fundData.length === 0) {
    return false
  }
  // Extract 'a' values from A and B
  const valuesFiundList = fundsList.map(obj => obj.externalID);
  const valuesFundData = fundData.map(obj => obj.externalID);

  // Sort the arrays
  valuesFiundList.sort();
  valuesFundData.sort();

  // Check if they are equal
  const areEqual = JSON.stringify(valuesFiundList) === JSON.stringify(valuesFundData);

  return !areEqual
}

async function processInitialStrctureRefresh(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate, fundData) {
  try{
    let blendedStructure = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_STRUCTURE, aggNoHistoryFlag, levelsEndDate))

    let tempHhold = blendedStructure.data
    tempHhold = tempHhold.map(item1 => {
      const item2 = fundData.find(item2 => item2.externalID === item1.externalID);
      return item2 ? item2 : item1;
    });
    blendedStructure.data = tempHhold
    const response = { data: { data: blendedStructure } }
    dispatch({ type: LOAD_PERFORMANCE, payload: response.data })
    dispatch({ type: SET_FUND_DETAILS_STRUCTURE, payload: response.data }) 
    dispatch({ type: FETCH_STRUCTURE_LOADING, payload: false})
    handleDefaultLoadingComplete(dispatch)
  } catch (error) {
    await dispatch({ type: FETCH_PERFORMANCE_LOADING, payload: false })
    await dispatch({ type: FETCH_CONSTITUENTS_LOADING, payload: false })
    await dispatch({ type: FETCH_CATCHALL_LOADING, payload: false})
    await dispatch({ type: FETCH_AGGS_LOADING, payload: false})
    await dispatch({ type: FETCH_RUN_ID_LOADING, payload: false})   

    await dispatch({ type: FETCH_PERFORMANCE_ERROR, payload: true })
    await dispatch({ type: FETCH_AGGS_ERROR, payload: true })
    await dispatch({ type: FETCH_CONSTITUENTS_ERROR, payload: true })
    await dispatch({ type: FETCH_CATCHALL_ERROR, payload: true })    
    await dispatch(setLoading(false))
    // await dispatch(updateQueryParams())
  }
}

async function processInitialStrcture(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate,) {
  try {
    const blendedStructure = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_STRUCTURE, aggNoHistoryFlag, levelsEndDate))
    const response = { data: { data: blendedStructure } }
    dispatch({ type: LOAD_PERFORMANCE, payload: response.data })
    dispatch({ type: SET_FUND_DETAILS_STRUCTURE, payload: response.data }) 
    dispatch({ type: FETCH_STRUCTURE_LOADING, payload: false})
    handleDefaultLoadingComplete(dispatch)
  } catch (error) {
    dispatch(setLoading(false))
    dispatch(updateQueryParams())

    await dispatch({ type: FETCH_PERFORMANCE_ERROR, payload: true })
    await dispatch({ type: FETCH_AGGS_ERROR, payload: true })
    await dispatch({ type: FETCH_CONSTITUENTS_ERROR, payload: true })
    await dispatch({ type: FETCH_CATCHALL_ERROR, payload: true })     
  }
}

async function processPerformance(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate) {
  try {
    const blendedPeformance = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_PERFORMANCE, aggNoHistoryFlag, levelsEndDate))
    const response = { data: { data: blendedPeformance } }
    await dispatch({ type: SET_FUND_DETAILS_PERFORMANCE, payload: response.data })  
    await dispatch({ type: FETCH_PERFORMANCE_LOADING, payload: false })
  } catch (error) {
    console.error(error);
    await dispatch({ type: FETCH_PERFORMANCE_ERROR, payload: true })    
    await dispatch({ type: FETCH_PERFORMANCE_LOADING, payload: false })
  }
}

async function processAggregates(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate) {
  try{
    const blendedAggs = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_AGGREGATES, aggNoHistoryFlag, levelsEndDate))
    const response = await { data: { data: blendedAggs } }
    await dispatch({ type: SET_FUND_DETAILS_AGGS, payload: response.data })  
    await dispatch({ type: FETCH_AGGS_LOADING, payload: false }) 
    if (!aggNoHistoryFlag) {
      await dispatch({ type: SET_AGGS_FULL_COMPLETED, payload: true })
      await dispatch({ type: FETCH_AGGS_FULL_LOADING, payload: false })
    } 
  } catch(error) {
    if(aggNoHistoryFlag){
      await dispatch({ type: FETCH_AGGS_ERROR, payload: true }) 
    }
    await dispatch({ type: FETCH_AGGS_LOADING, payload: false })     
  }
  
}

async function processConstituents(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate) {
  try{
    const blendedConstituents = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_CONSTITUENTS, aggNoHistoryFlag, levelsEndDate))
    const response = await { data: { data: blendedConstituents } }
    await dispatch({ type: SET_FUND_DETAILS_CONSTITUENTS, payload: response.data })  
    await dispatch({ type: FETCH_CONSTITUENTS_LOADING, payload: false })      
  } catch (error) {
    await dispatch({ type: FETCH_CONSTITUENTS_ERROR, payload: true })    
    await dispatch({ type: FETCH_CONSTITUENTS_LOADING, payload: false })
  }

}

async function processCatchAll(dispatch, fundsList, aggNoHistoryFlag, levelsEndDate) {
  try {
    if (!aggNoHistoryFlag) {
      await dispatch({ type: SET_AGGS_FULL_COMPLETED, payload: false })
      await dispatch({ type: FETCH_AGGS_FULL_LOADING, payload: true })
    }    
    const blendedCatchAll = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_CATCH, aggNoHistoryFlag, levelsEndDate))
    const response = await { data: { data: blendedCatchAll } }
    await dispatch({ type: SET_FUND_DETAILS_CATCHALL, payload: response.data })  
    await dispatch({ type: FETCH_CATCHALL_LOADING, payload: false }) 
  } catch(error) {
    if (aggNoHistoryFlag) {
      await dispatch({ type: FETCH_CATCHALL_ERROR, payload: true }) 
    }
    await dispatch({ type: FETCH_CATCHALL_LOADING, payload: false })     
  }
}

async function processPDFRunID(dispatch, fundsList, fundData, params) {
  fundData = fundData.map(item => {
    let removeEnrichment = {...item};
    delete removeEnrichment.esgOverallRiskMetrics;
    delete removeEnrichment.sectorSOEData;
    delete removeEnrichment.sectorNonSOEData;
    delete removeEnrichment.sectorNonSOEVals;
    delete removeEnrichment.sectorSOESubTotalVals;
    delete removeEnrichment.sectorSOESubTotals;
    delete removeEnrichment.countrySOEData;
    delete removeEnrichment.countrySOEVals;
    delete removeEnrichment.countryNonSOEVals;
    delete removeEnrichment.countrySOESubTotals;
    delete removeEnrichment.countrySOESubTotalVals;
    delete removeEnrichment.countrySOESubTotalVals; 
    delete removeEnrichment.msUrl;   
    return removeEnrichment;
  }); 

  // sometimes the post fails on the backend side. Unable to replicate. We try 3 times for sanity
  let attempts = 0;
  while(attempts < 15) {
    try {
      const blendedRunID = await dispatch(fetchBlendedData(fundsList, FUNDCHAR_URL_PDF_RUN_ID, true, null, fundData));
      await dispatch({ type: SET_FUND_DETAILS_RUN_ID, payload: {runId: blendedRunID?.runId, runEmail: blendedRunID?.email} });
      await dispatch({ type: FETCH_RUN_ID_LOADING, payload: false });
      break; // If successful, break the loop
    } catch (error) {
      console.error(error);
      attempts++; // Increase the attempt count
      if(attempts !== 8) { // If there are remaining attempts
        await new Promise(resolve => setTimeout(resolve, 1000)); // Wait for 1 seconds before the next attempt
      } else { // If all attempts failed
        await dispatch({ type: FETCH_RUN_ID_LOADING, payload: false });
        await dispatch({ type: FETCH_RUN_ID_ERROR, payload: true})
      }
    }
  }
  
}

async function handleDefaultLoading(dispatch) {
  await dispatch(setLoading(true))
  await dispatch(setError(false))
  await dispatch(clearInitialTickers())
  await dispatch(toggleFundSelection())
}

function handleDefaultLoadingComplete(dispatch) {
  dispatch(setLoading(false))
  dispatch(resetActivePane())
  dispatch(updateQueryParams())
}

async function fetchBlendedData(fundsList, dataURL, aggNoHistoryFlag = true, levelsEndDate = null, fundData=null) {
  return async (dispatch, getState) => {
    const { advisorEmail, token } = getState().params
    const url = new URL(dataURL);
    url.searchParams.append('advisorEmail', advisorEmail);
    url.searchParams.append('token', token);
    url.searchParams.append('oneYearCharachteristicsHistory', aggNoHistoryFlag);
    url.searchParams.append('levelsEndDate', levelsEndDate);

    // Create a cancellation token source
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    await dispatch({ type: ADD_PENDING_DATASPAN_REQUESTS, payload: source })

    const request = {
      method: 'POST',
      url: url.toString(),
      data: JSON.stringify({ tickers: fundsList, fundData: fundData }),
      headers: { 'Content-Type': 'application/json' },
      cancelToken: source.token  // Pass the cancellation token with your request
    }

    // Add event listener for page refresh or tab close
    window.addEventListener('beforeunload', (event) => {
      source.cancel('Operation canceled due to page refresh or tab close.');
    });

    try {
      const response = await axios(request)
      // Remove event listener after successful request
      window.removeEventListener('beforeunload', (event) => {
        source.cancel('Operation canceled due to page refresh or tab close.');
      });
      await dispatch({ type: REMOVE_PENDING_DATASPAN_REQUESTS, payload: source })
      return response.data
    } catch (error) {
      await dispatch({ type: REMOVE_PENDING_DATASPAN_REQUESTS, payload: source })
      if (axios.isCancel(error)) {
        console.log('Request canceled', error.message);
      } else {
        console.log(error)
        throw error
      }
    }
  }
}

async function cancelRequests(pendingDataspanRequests) {
  await pendingDataspanRequests.forEach(token => {
    token.cancel('Operation canceled by the user.');
  });
}


// ****** BLEND FUNCTIONS END ******

export function removeRelatedFund(fund) {
  return dispatch => {
    dispatch({ type: REMOVE_RELATED_FUND, payload: fund })
  }
}

export function loadFundDetailsFromExternalIDs(externalIDs, clearTickers = true) {
  return dispatch => {
    if (clearTickers) {
      dispatch(clearTickers())
    }
    const funds = externalIDs.map(extid => {
      return { externalID: extid }
    })
    dispatch(setFundTickers(funds))
    dispatch(loadFundDetails())
  }
}

export function loadFundDetailsFromTickers(tickers) {
  return dispatch => {
    dispatch(clearTickers())
    const data = { tickers: tickers }
    const request = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/fundchar/tickernames/`,
      data: data
    }
    return axios(request)
      .then(response => {
        dispatch(setFundTickers(response.data))
        dispatch(loadFundDetails())
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads data for fund - all characteristics & breakdowns
export function loadFundDetails() {
  return (dispatch, getState) => {
    dispatch(setError(false))
    dispatch(setLoading(true))
    dispatch(clearInitialTickers())
    dispatch(toggleFundSelection())
    dispatch({ type: CLEAR_SCREENED_FUNDS })
    dispatch({ type: CLEAR_SEARCH_RESULTS })
    let params = `${process.env.REACT_APP_API_URL}/fundchar/data?`
    params += `advisorEmail=${getState().params.advisorEmail}`
    const list = getState().params.selectedFunds
    list.forEach(element => {
      params += `&q=${element.externalID}`
    })

    const request = {
      method: 'GET',
      url: params
    }
    return axios(request)
      .then(response => {
        dispatch({ type: LOAD_RELATED_FUNDS, payload: [] })

        // Fund data array is in a data variable (response.data.data)
        dispatch({ type: SET_FUND_DETAILS_STRUCTURE, payload: response })
        dispatch(setLoading(false))
        dispatch(resetActivePane())
        saveToSalesforce(getState().params, response.data.data)
        dispatch(saveToGA('Analyze'))
        dispatch(saveToGA(getState().params.activePane))
        dispatch({ type: SET_FUND_DETAILS_RUN_ID, payload: {runId: response?.data?.runId, runEmail: response?.data?.email} });
        dispatch(updateQueryParams())
        dispatch(loadPerformance(getState().params.perfEndDate))
      })
      .catch(error => {
        dispatch(setLoading(false))
        dispatch(setError(true))
        dispatch(toggleFundSelection())
        console.log(error)
      })
  }
}

// loads data for fund - all characteristics & breakdowns
export function loadPerformance(date = null) {
  return (dispatch, getState) => {
    // dispatch({ type: LOAD_PERFORMANCE, payload: null })
    let params = `${process.env.REACT_APP_API_URL}/fundchar/performance?`
    const list = getState().params.selectedFunds
    list.forEach(element => {
      params += `&q=${element.externalID}`
    })
    if (date != null) {
      params += `&date=${date}`
    }
    const request = {
      method: 'GET',
      url: params
    }
    return axios(request)
      .then(response => {
        const restructure = { data: { data: response.data } }
        dispatch({ type: SET_FUND_DETAILS_PERFORMANCE, payload: restructure })
      })
      .catch(error => {
        console.log(error)
      })
  }
}

// loads the fund details excel
export function loadFundDetailsExcel(fullPeriod) {
  return (dispatch, getState) => {
    const fundData = getState().fundData.data
    let fileName = 'Fund-Comparison-Report.xlsx'
    let params = `${process.env.REACT_APP_API_URL}/fundchar/blends_excel/?`
    params += `advisorEmail=${getState().params.advisorEmail}`
    params += `&token=${getState().params.token}`
    params += `&excel=True`
    if (fullPeriod) {
      params += '&hist=true'
      fileName = 'Fund-Comparison-Report-Full-Period.xlsx'
    }
    if (getState().params.perfEndDate != null) {
      params += `&date=${getState().params.perfEndDate}`
    }

    if (fullPeriod) {
      dispatch({ type: SET_FULLEXCEL_STATUS, value: true })
      // dispatch(saveToGA('Export Full'))
    } else {
      dispatch({ type: SET_CURRENTEXCEL_STATUS, value: true })
      // dispatch(saveToGA('Export Current'))
    }
    const request = {
      method: 'POST',
      data: JSON.stringify({ fundData: fundData }),
      responseType: 'blob',
      url: params,
      headers: {
        'Content-Type': 'application/json'
      }
    }
    return axios(request)
      .then(response => {
        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
        if (window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(blob, fileName)
        } else {
          const url = window.URL.createObjectURL(blob)
          const a = document.createElement('a')
          a.href = url
          a.download = fileName
          a.click()
        }
        if (fullPeriod) {
          dispatch({ type: SET_FULLEXCEL_STATUS, value: false })
        } else {
          dispatch({ type: SET_CURRENTEXCEL_STATUS, value: false })
        }
      })
      .catch(error => {
        console.log(error)
        dispatch({ type: SET_FULLEXCEL_STATUS, value: false })
        dispatch({ type: SET_CURRENTEXCEL_STATUS, value: false })
      })
  }
}

/* sets selected category from fund Profile*/
export function setProfileCategory(param) {
  return dispatch => {
    dispatch({ type: SET_PROFILE_CATEGORY, payload: param })
  }
}

/* sets list of tickers to compare*/
export function setSelectedFundTickers(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_FUND_TICKERS, payload: param })
  }
}

export function setFundTickers(funds) {
  return dispatch => {
    dispatch({ type: SET_TA_FUND_TICKERS, payload: funds })
    dispatch(updateQueryParams())
  }
}

/* sets list of type ahead ids to compare*/
export function setTAFundTickers(param) {
  const funds = param.map(fund => {
    return {
      externalID: fund.value
    }
  })
  return dispatch => {
    dispatch({ type: SET_TA_FUND_TICKERS, payload: funds })
    dispatch(updateQueryParams())
  }
}

/* sets which page to show */
export function setActivePane(param) {
  return (dispatch, getState) => {
    dispatch({ type: SET_ACTIVE_PANE, payload: param })
    dispatch(updateQueryParams())
  }
}

export function resetActivePane() {
  return (dispatch, getState) => {
    const fundsWithTilts = getState().fundData.data.filter(x => x.multifactorTilts !== null)
    const fundsWithAggs = getState().fundData.data.filter(x => x.aggregateFundamentals !== null)
    if (getState().params.activePane === paneOpts.factors && fundsWithTilts.length === 0) {
      dispatch(setActivePane(paneOpts.perf))
    }
    if (getState().params.activePane === paneOpts.chars && fundsWithAggs.length === 0) {
      dispatch(setActivePane(paneOpts.perf))
    }
  }
}

/* used to restore option dropdown and funds so user can request a different list of data*/
export function resetPage(param) {
  return dispatch => {
    dispatch({ type: RESET_PAGE, payload: param })
  }
}

/* sets list of chars to display series chart data */
export function setSelectedChars(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_CHARS, payload: param })
  }
}

/* sets list of ESGRiskRating to display overall risk */
export function setSelectedRisk(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_RISK, payload: param })
  }
}
/* sets sector to display series chart data */
export function setSelectedSector(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_SECTOR, payload: param })
  }
}

/* sets country to display series chart data */
export function setSelectedCountry(param) {
  return dispatch => {
    dispatch({ type: SET_SELECTED_COUNTRY, payload: param })
  }
}

export function resetScrollCountry() {
  return dispatch => {
    dispatch({ type: RESET_SCROLL_COUNTRY })
  }
}

export function removeTicker(param) {
  return (dispatch, getState) => {
    dispatch({ type: REMOVE_TICKER, payload: param })
    dispatch(resetActivePane())
    dispatch(updateQueryParams())
  }
}

export function clearTickers() {
  return async (dispatch, getState) => {
    dispatch({ type: CLEAR_TICKERS })
    dispatch(updateQueryParams())    
    const pendingDataspanRequests = await getState().fundData.pendingDataspanRequests
    await cancelRequests(pendingDataspanRequests)

  }
}

export function editTickers() {
  return (dispatch, getState) => {
    dispatch({ type: EDIT_TICKERS })
    dispatch(editQueryParams())
  }
}

export function clearInitialTickers() {
  return dispatch => {
    dispatch({ type: CLEAR_INITIAL_TICKERS })
  }
}

export function setLoading(param) {
  return dispatch => {
    dispatch({ type: LOADING, payload: param })
  }
}

export function setProgressBarValue(value) {
  return dispatch => {
    dispatch({ type: SET_PROGRESS_BAR_VALUE, payload: value })
  }
}

export function setPerfLoading(param) {
  return dispatch => {
    dispatch({ type: PERF_LOADING, payload: param })
  }
}

export function setError(param) {
  return dispatch => {
    dispatch({ type: ERROR, payload: param })
  }
}

// Save the run of loaded funds to Salesforce
export function saveToSalesforce(params, fundData) {
  // Don't do anything if not FP (or if we don't have a token) as we don't have token or any
  // client data
  if (params.isFP === false || !params.token) {
    console.log('GP or missing token - do not save to sfdc')
    return null
  }

  // Set up the url endpoint
  const url = `${process.env.REACT_APP_API_URL}/fundchar/sfdc/activity/`.replace('/fundchar', '')

  const headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    Authorization: params.token && `Token ${params.token}`
  }

  // Set up the fund description data
  const description = fundData
    .map(fund => `${fund.ticker} (${fund.name})\n`)
    .toString()
    .replace(/,/g, '')

  // Get tickers for the header
  const heading = fundData.map(fund => `${fund.ticker}`).toString()

  // Set up the data to post for the activity
  const data = {
    clientEmail: params.advisorEmail,
    activityType: `DPD_FundComparison`,
    description: `Funds compared: \n\n ${description}`,
    subject: `${heading}`
  }

  const request = {
    method: 'POST',
    url: url,
    headers: headers,
    data: qs.stringify(data)
  }

  return axios(request)
    .then(response => {
      console.debug(response.data)
    })
    .catch(error => {
      console.log(error)
    })
}

export function setSelectedRelated(value) {
  return dispatch => {
    dispatch({ type: SELECTED_RELATED, payload: value })
  }
}

export function setPerfStartDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERF_START_DATE, payload: value })
    dispatch(updateQueryParams())
  }
}

export function setPerfEndDate(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_PERF_END_DATE, payload: value })
    dispatch(updateQueryParams())
  }
}

export function saveToGA(eventAction) {
  return (dispatch, getState) => {
    const e = {
      eventName: 'fund comparison',
      eventAction: eventAction,
      eventLabel: getState()
        .fundData.data.map(fund => `${fund.ticker}`)
        .join('|'),
      type: 'CustomTagEvent'
    }

    if (window.digitalData) {
      if (e.Label !== '') {
        window.digitalData.newEvent(e)
        console.log('digitalData: ', e)
      } else {
        console.warn('no digitial data')
      }
    }
  }
}

export function setMetricQuality(value) {
  return dispatch => {
    dispatch({ type: SET_GROWTH_METRIC_QUALITY, payload: value })
  }
}

export function setAllGrowthChars(value) {
  return dispatch => {
    dispatch({ type: SET_ALL_GROWTH_CHARS, payload: value })
  }
}

/* sets country to display series chart data */
export function setSeeAdditionalPI(param) {
  return dispatch => {
    dispatch({ type: SET_SELECT_ADDITIONALPI, payload: param })
  }
}

export function setActiveSoeDataType(value) {
  return dispatch => {
    // console.log('ACTIONS', value)
    dispatch({ type: SET_ACTIVE_SOE_DATA_TYPE, payload: value })
  }
}
/* sets which  soe level page to show */
export function setActiveSoePane(param) {
  return (dispatch, getState) => {
    dispatch({ type: SET_ACTIVE_SOE_PANE, payload: param })
  }
}

export function setDrawDownPeriod(value) {
  return (dispatch, getState) => {
    dispatch({ type: SET_DRAW_DOWN_PERIOD, payload: value })
    //dispatch(updateQueryParams());
  }
}

/* toggles the fund selection */
export function toggleFundSelection() {
  return (dispatch, getState) => {
    dispatch({ type: TOGGLE_SHOW_FUND_SELECTION })
  }
}

export function setLoadingSearchResults(param) {
  return dispatch => {
    dispatch({ type: LOADING_SEARCH_RESULTS, payload: param })
  }
}

// Search for funds using fund screener
export function searchForFunds(searchString) {
  return (dispatch, getState) => {
    dispatch(setError(false))
    dispatch(setLoadingSearchResults(true))

    let url = `${process.env.REACT_APP_API_URL}/fundchar/search/`
    const request = {
      method: 'GET',
      url: url,
      params: {
        q: searchString
      }
    }
    return axios(request)
      .then(response => {
        // Enrich fund data
        const searchFunds = response.data.map(fund => {
          fund.inceptionDt = new Date(fund.inceptionDate)
          return fund
        })
        dispatch({ type: LOAD_SEARCH_RESULTS, payload: searchFunds })
        dispatch(setError(false))
        dispatch(setLoadingSearchResults(false))
      })
      .catch(error => {
        dispatch(setLoadingSearchResults(false))
        dispatch(setError(true))
        console.log(error)
      })
  }
}

export function addScreenedFund(fund) {
  return dispatch => {
    dispatch({ type: ADD_SCREENED_FUND, payload: fund })
  }
}

export function loadPersonalStrategies() {
  return (dispatch, getState) => {
    let params = getState().params

    if (params.token !== 'undefined') {
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/`,
        params: {
          clientEmail: params.advisorEmail
        },
        headers: {
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          if (response.status === 200) {
            const sortedData = [...response.data].sort((a, b) => {
              // Sort a and b
              return new Date(a.updateDate) >= new Date(b.updateDate) ? -1 : 1
            })
            dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: sortedData })
          }
        })

        .catch(error => {
          if (error.response.status === 404) {
            dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: [] })
          }
        })
    } // If token isn't valid then don't load anything
    else {
      dispatch({ type: LOAD_PERSONAL_STRATEGIES, payload: [] })
    }
  }
}

export function showPersonalStrategy(idToShow) {
  return (dispatch, getState) => {
    dispatch({ type: SHOW_A_STRATEGY, payload: idToShow })
  }
}

// Show all strategies in the StrategyList
export function showAllStrategies() {
  return (dispatch, getState) => {
    dispatch({ type: SHOW_ALL_STRATEGIES })
  }
}

// Show the Strategy editor. May be called from the StrategyList
// or an individual StrategyRow
export function showStrategyEditor(personalStrategy) {
  console.log('showStrategyEditor', personalStrategy)
  return (dispatch, getState) => {
    dispatch({ type: SHOW_STRATEGY_EDITOR, payload: personalStrategy })
  }
}

// Close the StrategyEditor
export function closeStrategyEditor() {
  return (dispatch, getState) => {
    dispatch({ type: CLOSE_STRATEGY_EDITOR })
  }
}

// Update the Personal Strategy's details (e.g., name)
export function saveNewStrategy(fieldsToUpdate) {
  return (dispatch, getState) => {
    // Let the StrategyList know that a new strategy is being saved
    dispatch({ type: SAVING_NEW_STRATEGY_IN_PROGRESS, payload: fieldsToUpdate })

    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      wtRegion: params.wtRegion,
      name: fieldsToUpdate.name,
      holdings: fieldsToUpdate.holdings,
      totalValue: fieldsToUpdate.totalValue
    }

    // Add a benchmark if one has been added
    if (fieldsToUpdate.benchmarkExternalID) {
      body.benchmarks = [
        {
          externalID: fieldsToUpdate.benchmarkExternalID
        }
      ]
    }

    if (params.token !== 'undefined') {
      const request = {
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: SAVE_NEW_STRATEGY, payload: response.data })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE- sav personal strat', response)
          console.log('REQUEST- sav personal strat', request)
          // Update the Hash URL to force dpd to reload
          window.location = '#myportfolios&reloadhistory=true'

          // Optimize the strategy now it's been created
          optimizePersonalStrategy(dispatch, params, response.data.id)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

// Update the Personal Strategy's details (e.g., name)
export function updateStategyDetails(fieldsToUpdate) {
  return (dispatch, getState) => {
    // Let the StrategyList know that one of the strategies is being saved
    dispatch({ type: SAVING_STRATEGY_IN_PROGRESS, payload: fieldsToUpdate.id })

    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      name: fieldsToUpdate.name,
      totalValue: fieldsToUpdate.totalValue
    }

    // Check if holdings were updated
    if (fieldsToUpdate.holdings) {
      body.holdings = fieldsToUpdate.holdings
    }

    // Add a benchmark if one has been added, otherwise force it to be blanked out with empty array
    if (fieldsToUpdate.benchmarkExternalID) {
      body.benchmarks = [
        {
          externalID: fieldsToUpdate.benchmarkExternalID
        }
      ]
    } else {
      body.benchmarks = []
    }

    if (params.token !== 'undefined' && fieldsToUpdate.id) {
      const request = {
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/${fieldsToUpdate.id}/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: UPDATE_STRATEGY, payload: response.data })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE- opt ', response)
          console.log('REQUEST - opt', request)
          // Update the Hash URL to force dpd to reload
          window.location = '#myportfolios&reloadhistory=true'

          // Check if holdings were updated
          if (fieldsToUpdate.holdings) {
            // Optimize the strategy now it's been created
            optimizePersonalStrategy(dispatch, params, fieldsToUpdate.id)
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

function optimizePersonalStrategy(dispatch, params, idToOptimize) {
  const body = {
    clientEmail: params.clientEmail
  }

  if (params.token !== 'undefined' && idToOptimize) {
    const request = {
      method: 'POST',
      url: `${process.env.REACT_APP_API_URL}/personalstrategies/${idToOptimize}/optimize/`,
      data: body,
      headers: {
        'Content-Type': 'application/json',
        Authorization: params.token && `Token ${params.token}`
      }
    }
    return axios(request)
      .then(response => {
        dispatch({ type: UPDATE_STRATEGY, payload: response.data })
        console.log('RESPONSE-updatek', response)
        console.log('REQUEST -update', request)
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export function deletePersonalStrategy(idToDelete) {
  return (dispatch, getState) => {
    // Let the StrategyList know that one of the strategies is being deleted
    dispatch({ type: SAVING_STRATEGY_IN_PROGRESS, payload: idToDelete })

    let params = getState().params

    const body = {
      clientEmail: params.clientEmail,
      isDeleted: true
    }

    if (params.token !== 'undefined' && idToDelete) {
      const request = {
        method: 'PUT',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/${idToDelete}/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: DELETE_A_STRATEGY, payload: idToDelete })
          dispatch({ type: SHOW_ALL_STRATEGIES })
          dispatch({ type: SAVING_STRATEGY_COMPLETE })
          console.log('RESPONSE-del personal strat', response)
          console.log('REQUEST del personal strat', request)
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

// Create a new strategy out of a portfolio from DPD
export function savePortfolioAsNewStrategy(portfolioId, portfolioName) {
  return (dispatch, getState) => {
    let params = getState().params

    let body = {
      clientEmail: params.clientEmail,
      portfolioId: portfolioId,
      portfolioName: portfolioName
    }

    if (params.token !== 'undefined' && portfolioId) {
      const request = {
        method: 'POST',
        url: `${process.env.REACT_APP_API_URL}/personalstrategies/create_from_portfolio/`,
        data: body,
        headers: {
          'Content-Type': 'application/json',
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          dispatch({ type: SAVE_NEW_STRATEGY, payload: response.data })

          // Update the Hash URL to let DPD know saving has finished
          window.location = '#dpd&savedToMyPortfolios=' + portfolioId + '&newMyPortfolio=' + response.data.id
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

/// Get all the benchmarks from the database
export function getBenchmarks() {
  return (dispatch, getState) => {
    let params = getState().params

    if (params.token !== undefined) {
      const request = {
        method: 'GET',
        url: `${process.env.REACT_APP_DPD_URL}/api/benchmarks/all/`,
        params: {
          clientEmail: params.clientEmail,
          entityCCY: params.entityCCY,
          wtRegion: params.wtRegion
        },
        headers: {
          Authorization: params.token && `Token ${params.token}`
        }
      }
      return axios(request)
        .then(response => {
          if (response.status === 200) {
            dispatch({ type: LOAD_BENCHMARKS, payload: response.data })
          }
        })
        .catch(error => {
          console.error(error)
        })
    }
  }
}

export function removeScreendFund(fund) {
  return dispatch => {
    dispatch({ type: REMOVE_SCREENED_FUND, payload: fund })
  }
}

export function updateSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: UPDATE_SEARCH_TICKER, payload: ticker })
  }
}

export function removeSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: REMOVE_SEARCH_TICKER, payload: ticker })
  }
}

export function appendSearchTicker(ticker) {
  return dispatch => {
    dispatch({ type: APPEND_SEARCH_TICKER, payload: ticker })
  }
}

export function updateFundCount(fund) {
  return dispatch => {
    dispatch({ type: UPDATE_FUND_COUNT, payload: fund })
  }
}
